import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh-icon',
  templateUrl: './refresh-icon.component.html',
  styleUrl: './refresh-icon.component.scss',
})
export class RefreshIconComponent {}
